import React from "react";
import { Link, Redirect } from "react-router-dom";
import * as Icon from "react-feather";
import axios from "../util/Api";
import { tokensKey } from "../util/Constants";
import getStorage from "../context/auth";
import { Spin } from "antd";

class Login extends React.Component {
  constructor(props) {
    super(props);
    // Default referer is /profile if none is provided via location state.
    const referer = props.location?.state?.referer || "/profile";
    this.state = {
      isLoggedIn: false,
      isError: false,
      userName: "",
      password: "",
      referer,
      loading: false,
    };
  }

  postLogin = (e) => {
    e.preventDefault();
    const { userName, password } = this.state;
    this.setState({ loading: true });

    axios
      .post("/api/auth/local", { identifier: userName, password })
      .then((result) => {
        if (result.status === 200) {
          // Clear any previously stored tokens and store the new ones
          getStorage().clear();
          getStorage().setItem(tokensKey, JSON.stringify(result.data));
          // Call the parent callback to update login state
          this.props.onLoginSuccess();
          // Set isLoggedIn flag to true so that redirect takes effect
          this.setState({ isLoggedIn: true, isError: false, loading: false });
        } else {
          this.setState({ isError: true, loading: false });
        }
      })
      .catch(() => {
        this.setState({ isError: true, loading: false });
      });
  };

  render() {
    const { isError, loading, isLoggedIn, referer } = this.state;
    
    // If login is successful, render a <Redirect> to the referer (or /profile)
    if (isLoggedIn) {
      return <Redirect to={referer || "/profile"} />;
    }

    return (
      <section className="bg-light bg-home d-flex align-items-center">
        <div className="back-to-home rounded d-none d-sm-block">
          <Link to="/" className="btn btn-icon btn-soft-primary">
            <Icon.Home className="icons" />
          </Link>
        </div>
        <div className="bg-overlay bg-overlay-white" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-8">
              <div className="card login-page bg-white shadow rounded border-0">
                <div className="card-body">
                  <div className="row justify-content-center">
                    <img src="images/logo-light.png" height={45} alt="logo" />
                  </div>
                  <h4 className="card-title text-center">Login</h4>
                  {/* Attach onSubmit handler on the form element */}
                  <form className="login-form mt-4" onSubmit={this.postLogin}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group position-relative">
                          <label>
                            Votre email ou nom d'utilisateur{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Icon.User className="fea icon-sm icons" />
                          <input
                            type="text"
                            className="form-control pl-5"
                            placeholder="Email ou nom d'utilisateur"
                            name="email"
                            required
                            onChange={(e) =>
                              this.setState({ userName: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group position-relative">
                          <label>
                            Mot de passe <span className="text-danger">*</span>
                          </label>
                          <Icon.Key className="fea icon-sm icons" />
                          <input
                            type="password"
                            className="form-control pl-5"
                            placeholder="Mot de passe"
                            required
                            onChange={(e) =>
                              this.setState({ password: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        {isError && (
                          <span style={{ color: "red" }}>
                            Nom d'utilisateur / mot de passe invalides
                          </span>
                        )}
                      </div>
                      <div className="col-lg-12 mb-0">
                        <button type="submit" className="btn btn-primary btn-block">
                          {loading ? <Spin /> : "S'authentifier"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {/* End of card */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Login;